import { ICommandGroupMap } from 'src/common/interfaces/dtos/ICommandsGroup';
import { ITabs } from 'src/common/interfaces/dtos/ITabs';
import { CommandMenuType, IPosUiMenu } from 'src/common/interfaces/states/IPosUiMenuState';

export const defaultTabs: ITabs = {
  DefaultTabGroup: {
    id: 'DefaultTabGroup',
    tabs: [
      {
        tabId: 'action-window',
        displayName: 'Action Window',
        isActive: true,
        isReserved: true,
        tabOrder: 0,
      },
      {
        tabId: 'customer-service',
        displayName: 'Customer Service',
        isActive: true,
        isReserved: false,
        tabOrder: 1,
      },
      {
        tabId: 'cash-office',
        displayName: 'Cash Office',
        isActive: true,
        isReserved: false,
        tabOrder: 2,
      },
      {
        tabId: 'peripherals',
        displayName: 'Peripherals',
        isActive: false,
        isReserved: false,
        tabOrder: 3,
      },
      {
        tabId: 'recall-order',
        displayName: 'Recall Order',
        isActive: true,
        isReserved: true,
        tabOrder: 4,
      },
    ],
  },
  ActiveSaleTabGroup: {
    id: 'ActiveSaleTabGroup',
    tabs: [
      {
        tabId: 'action-window',
        displayName: 'Action Window',
        isActive: true,
        isReserved: true,
        tabOrder: 0,
      },
      {
        tabId: 'customer-service',
        displayName: 'Customer Service',
        isActive: true,
        isReserved: false,
        tabOrder: 1,
      },
      {
        tabId: 'cash-office',
        displayName: 'Cash Office',
        isActive: true,
        isReserved: false,
        tabOrder: 2,
      },
      {
        tabId: 'peripherals',
        displayName: 'Peripherals',
        isActive: false,
        isReserved: false,
        tabOrder: 3,
      },
      {
        tabId: 'recall-order',
        displayName: 'Recall Order',
        isActive: true,
        isReserved: true,
        tabOrder: 4,
      },
    ],
  },
};

export const defaultFocusMenu = {
  menuType: CommandMenuType.Focus,
  commands: [
    {
      commandId: 'VoidTransactionCommand',
      commandIcon: '',
      commandOrder: '1',
      states: [
        {
          state: 'SaleTransactionCommands',
          enabled: true,
        },
        {
          state: 'ReturnTransactionCommandGroup',
          enabled: true,
        },
      ],
    },
    {
      commandId: 'PriceQueryCommand',
      commandIcon: '',
      commandOrder: '2',
      states: [
        {
          state: 'SaleTransactionCommands',
          enabled: true,
        },
        {
          state: 'NoSaleTransactionCommands',
          enabled: true,
        },
      ],
    },
    {
      commandId: 'PreSalePriceOverrideCommand',
      commandIcon: '',
      commandOrder: '3',
      states: [
        {
          state: 'SaleTransactionCommands',
          enabled: true,
        },
        {
          state: 'NoSaleTransactionCommands',
          enabled: true,
        },
      ],
    },
    {
      commandId: 'SetGetItemToReturnStateCommand',
      commandIcon: '',
      commandOrder: '4',
      states: [
        {
          state: 'SaleTransactionCommands',
          enabled: true,
        },
        {
          state: 'NoSaleTransactionCommands',
          enabled: true,
        },
      ],
    },
    {
      commandId: 'ApplyTransactionTaxExemptionCommand',
      commandIcon: '',
      commandOrder: '5',
      states: [
        {
          state: 'SaleTransactionCommands',
          enabled: true,
        },
      ],
    },
    {
      commandId: 'ApplyItemTaxExemptionCommand',
      commandIcon: '',
      commandOrder: '6',
      states: [
        {
          state: 'SaleTransactionCommands',
          enabled: true,
        },
      ],
    },
    {
      commandId: 'GoToSaleModeCommand',
      commandIcon: '',
      commandOrder: '7',
      states: [
        {
          state: 'ReturnTransactionCommandGroup',
          enabled: true,
        },
      ],
    },
    {
      commandId: 'DepartmentReturnCommand',
      commandIcon: '',
      commandOrder: '8',
      states: [
        {
          state: 'ReturnTransactionCommandGroup',
          enabled: true,
        },
      ],
    },
    {
      commandId: 'VoidTenderCommand',
      commandIcon: '',
      commandOrder: '9',
      states: [
        {
          state: 'TenderDetailsViewCommands',
          enabled: true,
        },
      ],
    },
    {
      commandId: 'CancelLineItemCommand',
      commandIcon: '',
      commandOrder: '10',
      states: [
        {
          state: 'ItemsPostSaleCommands',
          enabled: true,
        },
        {
          state: 'ItemWithTareCommands',
          enabled: true,
        },
      ],
    },
    {
      commandId: 'CancelItemFromLineItemCommand',
      commandIcon: '',
      commandOrder: '11',
      states: [
        {
          state: 'ItemsPostSaleCommands',
          enabled: true,
        },
        {
          state: 'ItemWithTareCommands',
          enabled: true,
        },
      ],
    },
    {
      commandId: 'SetCancelItemStateCommand',
      commandIcon: '',
      commandOrder: '12',
      states: [
        {
          state: 'ItemsPostSaleCommands',
          enabled: true,
        },
      ],
    },
    {
      commandId: 'PriceOverrideCommand',
      commandIcon: '',
      commandOrder: '13',
      states: [
        {
          state: 'ItemsPostSaleCommands',
          enabled: true,
        },
        {
          state: 'ItemWithTareCommands',
          enabled: true,
        },
        {
          state: 'ReturnTransactionItemsPostSaleCommands',
          enabled: true,
        },
      ],
    },
    {
      commandId: 'EnhancedPriceOverrideCommand',
      commandIcon: '',
      commandOrder: '14',
      states: [
        {
          state: 'ItemsPostSaleCommands',
          enabled: true,
        },
        {
          state: 'ItemWithTareCommands',
          enabled: false,
        },
        {
          state: 'ReturnTransactionItemsPostSaleCommands',
          enabled: false,
        },
      ],
    },
    {
      commandId: 'ModifyTareCommand',
      commandIcon: '',
      commandOrder: '15',
      states: [
        {
          state: 'ItemWithTareCommands',
          enabled: false,
        },
      ],
    },
    {
      commandId: 'CancelCouponLineCommand',
      commandIcon: '',
      commandOrder: '16',
      states: [
        {
          state: 'CouponModeCommands',
          enabled: true,
        },
      ],
    },
    {
      commandId: 'CouponRewardOverrideCommand',
      commandIcon: '',
      commandOrder: '17',
      states: [
        {
          state: 'CouponModeCommands',
          enabled: true,
        },
      ],
    },
  ],
};

export const defaultInfoMenu: IPosUiMenu = {
  menuType: CommandMenuType.Info,
  commands: [
    {
      commandOrder: '1',
      commandIcon: 'MonetizationOnOutlined',
      commandId: 'ShowPromotionsCommand',
      states: [
        {
          state: '',
          enabled: true,
        },
      ],
    },
    {
      commandOrder: '2',
      commandIcon: 'ConfirmationNumberOutlined',
      commandId: 'ShowCouponsCommand',
      states: [
        {
          state: '',
          enabled: true,
        },
      ],
    },
    {
      commandOrder: '3',
      commandIcon: 'CardGiftcard',
      commandId: 'ShowGiftCardsCommand',
      states: [
        {
          state: '',
          enabled: true,
        },
      ],
    },
  ],
};

export const defaultLogOffMenu: IPosUiMenu = {
  menuType: CommandMenuType.LogOff,
  commands: [
    {
      commandOrder: '1',
      commandIcon: '',
      commandId: 'OpenCashDrawerOnSignoffCommand',
      states: [
        {
          state: 'HelloLoginModeCommandsGroup',
          enabled: true,
        },
      ],
      checkRole: false,
      userHasPermission: true,
      allowOverride: false,
    },
    {
      commandId: 'TillClosingCommand',
      commandIcon: '',
      commandOrder: '2',
      states: [
        {
          state: 'HelloLoginModeCommandsGroup',
          enabled: true,
        },
      ],
      checkRole: false,
      userHasPermission: true,
      allowOverride: false,
    },
    {
      commandId: 'ReInitDevicesCommand',
      commandIcon: '',
      commandOrder: '3',
      states: [
        {
          state: 'HelloLoginModeCommandsGroup',
          enabled: true,
        },
      ],
      checkRole: false,
      userHasPermission: true,
      allowOverride: false,
    },
    {
      commandId: 'ForgotPasswordCommand',
      commandIcon: '',
      commandOrder: '4',
      states: [
        {
          state: 'HelloLoginModeCommandsGroup',
          enabled: true,
        },
      ],
      checkRole: false,
      userHasPermission: true,
      allowOverride: false,
    },
    {
      commandId: 'CashierBarcodeCommand',
      commandIcon: '',
      commandOrder: '5',
      states: [
        {
          state: 'HelloLoginModeCommandsGroup',
          enabled: true,
        },
      ],
      checkRole: false,
      userHasPermission: true,
      allowOverride: false,
    },
  ],
};

export const defaultPopularMenu: IPosUiMenu = {
  menuType: CommandMenuType.Popular,
  commands: [
    {
      commandId: 'SearchCommand',
      commandIcon: 'Search',
      commandOrder: '1',
      states: [
        {
          state: 'ANY',
          enabled: true,
        },
      ],
    },
    {
      commandId: 'ShowNotificationsCommand',
      commandIcon: 'NotificationsNone',
      commandOrder: '2',
      states: [
        {
          state: 'ANY',
          enabled: true,
        },
      ],
    },
    {
      commandId: 'DeviceStatusCommand',
      commandIcon: 'Wifi',
      commandOrder: '3',
      states: [
        {
          state: 'WIFI_ON',
          enabled: true,
        },
      ],
    },
    {
      commandId: 'DeviceStatusCommand',
      commandIcon: 'WifiOff',
      commandOrder: '3',
      states: [
        {
          state: 'WIFI_OFF',
          enabled: true,
        },
      ],
    },
    {
      commandId: 'LockTerminalCommand',
      commandIcon: 'LockOpenOutlined',
      commandOrder: '4',
      states: [
        {
          state: 'UNLOCKED',
          enabled: true,
        },
      ],
    },
    {
      commandId: 'LockTerminalCommand',
      commandIcon: 'LockOutlined',
      commandOrder: '4',
      states: [
        {
          state: 'LOCKED',
          enabled: true,
        },
      ],
    },
  ],
};

export const defaultUserMenu = {
  menuType: CommandMenuType.User,
  commands: [
    {
      commandOrder: '1',
      commandIcon: 'device-settings',
      commandId: 'ShowCashierPreferencesCommand',
      states: [
        {
          state: 'ANY',
          enabled: true,
        },
      ],
    },
  ],
};

export const defaultCommandMenu: ICommandGroupMap = {
  SaleTransactionCommands: {
    isPermittedForCurrentUser: true,
    commandsList: [
      { name: 'VoidTransactionCommand', commandOrder: '1' },
      { name: 'PriceQueryCommand', commandOrder: '2' },
      { name: 'PreSalePriceOverrideCommand', commandOrder: '3' },
      { name: 'SetGetItemToReturnStateCommand', commandOrder: '4' },
      { name: 'ApplyTransactionTaxExemptionCommand', commandOrder: '5' },
      { name: 'ApplyItemTaxExemptionCommand', commandOrder: '6' },
      { name: 'OnlineItemBalanceQueryCommand', commandOrder: '18' },
      { name: 'VoucherBarcodeCommand', commandOrder: '20' },
      { name: 'TopUpCommand', commandOrder: '22' },
      { name: 'SuspendTransactionCommand', commandOrder: '23' },
      { name: 'ResumeTransactionCommand', commandOrder: '24', isActive: false },
    ],
  },
  ReturnTransactionCommandGroup: {
    isPermittedForCurrentUser: true,
    commandsList: [
      { name: 'VoidTransactionCommand', commandOrder: '1' },
      { name: 'GoToSaleModeCommand', commandOrder: '7' },
      { name: 'DepartmentReturnCommand', commandOrder: '8' },
    ],
  },
  TenderTransactionCommands: {
    isPermittedForCurrentUser: true,
    commandsList: [
      { name: 'VoidTransactionCommand', commandOrder: '1' },
      { name: 'PreSalePriceOverrideCommand', commandOrder: '3' },
      { name: 'OnlineItemBalanceQueryCommand', commandOrder: '18' },
    ],
  },
  NoSaleTransactionCommands: {
    isPermittedForCurrentUser: true,
    commandsList: [
      { name: 'PriceQueryCommand', commandOrder: '2' },
      { name: 'PreSalePriceOverrideCommand', commandOrder: '3' },
      { name: 'SetGetItemToReturnStateCommand', commandOrder: '4' },
      { name: 'OnlineItemBalanceQueryCommand', commandOrder: '18' },
      { name: 'ReprintCommand', commandOrder: '19' },
      { name: 'TopUpCommand', commandOrder: '22' },
      { name: 'ResumeTransactionCommand', commandOrder: '24' },
      {
        name: 'TenderExchangeCommand',
        commandsList: [
          {
            name: 'TenderExchangeCommand',
            parameters: [
              { name: 'TenderExchange', value: '123' },
              { name: 'description', value: 'TenderCorrection' },
            ],
            commandOrder: '1',
            description: 'TenderCorrection',
          },
          {
            name: 'TenderExchangeCommand',
            parameters: [
              { name: 'TenderExchange', value: '126' },
              { name: 'description', value: 'CashWithdrawal' },
            ],
            commandOrder: '3',
            description: 'CashWithdrawal',
          },
          {
            name: 'TenderExchangeCommand',
            parameters: [
              { name: 'TenderExchange', value: '125' },
              { name: 'description', value: 'Coin Star Voucher' },
            ],
            commandOrder: '2',
            description: 'Coin Star Voucher',
          },
        ],
        commandOrder: '25',
      },
    ],
  },
  TenderDetailsViewCommands: {
    isPermittedForCurrentUser: true,
    commandsList: [{ name: 'VoidTenderCommand', commandOrder: '9' }],
  },
  ItemsPostSaleCommands: {
    isPermittedForCurrentUser: true,
    commandsList: [
      { name: 'CancelLineItemCommand', commandOrder: '10' },
      { name: 'CancelItemFromLineItemCommand', commandOrder: '11' },
      { name: 'SetCancelItemStateCommand', commandOrder: '12' },
      { name: 'PriceOverrideCommand', commandOrder: '13' },
      { name: 'EnhancedPriceOverrideCommand', commandOrder: '14' },
    ],
  },
  ItemWithTareCommands: {
    isPermittedForCurrentUser: true,
    commandsList: [
      { name: 'CancelLineItemCommand', commandOrder: '10' },
      { name: 'PriceOverrideCommand', commandOrder: '13' },
      { name: 'EnhancedPriceOverrideCommand', commandOrder: '14', isActive: false },
      { name: 'ModifyTareCommand', commandOrder: '15', isActive: false },
    ],
  },
  ReturnTransactionItemsPostSaleCommands: {
    isPermittedForCurrentUser: true,
    commandsList: [
      { name: 'PriceOverrideCommand', commandOrder: '13' },
      { name: 'EnhancedPriceOverrideCommand', commandOrder: '14' },
    ],
  },
  CouponModeCommands: {
    isPermittedForCurrentUser: true,
    commandsList: [
      { name: 'CancelCouponLineCommand', commandOrder: '16' },
      { name: 'CouponRewardOverrideCommand', commandOrder: '17' },
    ],
  },
  ItemGroupActionCommands: {
    isPermittedForCurrentUser: true,
    commandsList: [{ name: 'AddManualTareCommand', commandOrder: '21' }],
  },
};
